import Vue from 'vue';

import Rollbar from 'rollbar';
import 'normalize.css';

import '@/css/Variables.css';
import '@/css/Elements.css';
import '@/css/Objects.css';

import router from '@/router';
import App from '@/App';

import DefaultLayout from '@/layouts/DefaultLayout';

Vue.prototype.$rollbar = new Rollbar({
  accessToken: process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  enabled: (
    process.env.VUE_APP_ROLLBAR_ACCESS_TOKEN
    && (process.env.NODE_ENV === 'production')
  ),
  payload: {
    environment: process.env.VUE_APP_MODE || process.env.NODE_ENV,
  },
  scrubFields: [
    'token',
    'x-authSessionId',
  ],
});

Vue.config.productionTip = false;
Vue.config.errorHandler = (error, vm) => {
  vm.$rollbar.error(error);
  throw error;
};

Vue.component('default-layout', DefaultLayout);

new Vue({
  router,
  render: (h) => h(App),
}).$mount('#app');
